import { ref, markRaw } from "vue";

interface ConfirmOptions {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  type?: "default" | "danger";
}

interface ConfirmDialogState {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  type: "default" | "danger";
  resolve: ((value: boolean) => void) | null;
}

const state = ref<ConfirmDialogState>({
  isOpen: false,
  title: "Confirm",
  message: "Are you sure?",
  confirmText: "OK",
  cancelText: "Cancel",
  type: "default",
  resolve: null,
});

export function useConfirmDialog() {
  const confirm = (options: ConfirmOptions = {}): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
      state.value = {
        isOpen: true,
        title: options.title || "Confirm",
        message: options.message || "Are you sure?",
        confirmText: options.confirmText || "OK",
        cancelText: options.cancelText || "Cancel",
        type: options.type || "default",
        resolve: markRaw(resolve),
      };
    });
  };

  const handleConfirm = () => {
    if (state.value.resolve) {
      state.value.resolve(true);
    }
    close();
  };

  const handleCancel = () => {
    if (state.value.resolve) {
      state.value.resolve(false);
    }
    close();
  };

  const close = () => {
    state.value.isOpen = false;
    state.value.resolve = null;
  };

  return {
    state,
    confirm,
    handleConfirm,
    handleCancel,
    close,
  };
}
